const getListResult = (state) => {
    return state.listResult;
};
//
export default {
    getListResult
};